import { BrowserRouter } from "react-router-dom";
import GuestRoutes from "./GuestRoutes";
import "bootstrap/dist/css/bootstrap.css";
import { Toaster } from "react-hot-toast";
import { useEffect, useState } from "react";
import { Provider, useDispatch, useSelector } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./redux/store";
import { reduxFetchUserLoginDetail } from "./redux/auth/auth";
import { ThemeProvider } from "./utils/theme";
import {
  listenForegroundMessages,
  registerFirebaseMessagingServiceWorker,
  requestNotificationPermission,
} from "./utils/firebaseNotification";
import "./App.css";

function AppContent() {
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.auth.userDetail);
  const [foregroundNotification, setForegroundNotification] = useState(null);

  useEffect(() => {
    dispatch(reduxFetchUserLoginDetail());
    registerFirebaseMessagingServiceWorker().then((reg) => {
      if (reg) {
        console.log("Firebase SW registered:", reg);
      }
    });
  }, [dispatch]);
  useEffect(() => {
    const script = document.createElement('script');
    script.src = '/assets/digio.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);


  useEffect(() => {
    let cleanupForegroundListener = null;
    let isMounted = true;

    listenForegroundMessages().then((unsubscribe) => {
      if (isMounted) {
        cleanupForegroundListener = unsubscribe;
      } else if (typeof unsubscribe === "function") {
        unsubscribe();
      }
    });

    return () => {
      isMounted = false;

      if (typeof cleanupForegroundListener === "function") {
        cleanupForegroundListener();
      }
    };
  }, []);

  useEffect(() => {
    if (userDetail?.id) {
      requestNotificationPermission(userDetail.id);
    }
  }, [userDetail?.id]);

  useEffect(() => {
    const handleForegroundMessage = (event) => {
      setForegroundNotification(event.detail);
    };

    window.addEventListener("firebase-foreground-message", handleForegroundMessage);

    return () => {
      window.removeEventListener("firebase-foreground-message", handleForegroundMessage);
    };
  }, []);

  useEffect(() => {
    if (!foregroundNotification) {
      return undefined;
    }

    const timer = window.setTimeout(() => {
      setForegroundNotification(null);
    }, 8000);

    return () => window.clearTimeout(timer);
  }, [foregroundNotification]);

  const handleForegroundNotificationClick = () => {
    if (foregroundNotification?.url) {
      window.location.assign(foregroundNotification.url);
    }

    setForegroundNotification(null);
  };

  return (
    <>
      {process.env.REACT_APP_REMOTE_ORIGIN !== "https://eapi.equitypandit.in" && (
        <div
          style={{
            position: "fixed",
            top: "70px",
            left: "-20px",
            backgroundColor: "#d32f2f",
            color: "white",
            padding: "5px 70px",
            fontWeight: "bold",
            fontSize: "14px",
            transform: "rotate(-30deg)",
            transformOrigin: "top left",
            boxShadow: "2px 2px 5px rgba(0,0,0,0.2)",
            zIndex: 3000,
          }}
        >
          Staging
        </div>
      )}

      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          style: {
            background: "#ffffff",
            color: "#111827",
          },
        }}
      />
      {foregroundNotification && (
        <button
          type="button"
          className="foreground-notification"
          onClick={handleForegroundNotificationClick}
        >
          <span className="foreground-notification__title">
            {foregroundNotification.title}
          </span>
          {foregroundNotification.body && (
            <span className="foreground-notification__body">
              {foregroundNotification.body}
            </span>
          )}
        </button>
      )}
      <BrowserRouter>
        <GuestRoutes />
      </BrowserRouter>
    </>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider>
          <AppContent />
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
}
